import * as tslib_1 from "tslib";
import * as customer from '../actions/customer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { generateEntities } from '../../core/helpers/entities';
var initialState = {
    ids: [],
    customers: {},
    selectedCustomer: null,
    error: null,
    searchTerm: null,
    loading: false,
    loaded: false,
    total: 0,
    currentPage: 1,
    nextPage: 2,
    totalPages: 1
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    var wrap;
    var generatedData;
    switch (action.type) {
        case customer.GET:
            return tslib_1.__assign({}, state, { loading: true, loaded: false });
        case customer.GET_SUCCESS:
            wrap = action.payload;
            generatedData = generateEntities(wrap);
            return tslib_1.__assign({}, state, { loading: false, loaded: true, ids: generatedData.ids, customers: generatedData.entities, selectedCustomer: null, currentPage: 1, searchTerm: null, nextPage: 2, totalPages: generatedData.totalPages, total: generatedData.totalCount });
        case customer.GET_FAILED:
            return tslib_1.__assign({}, state, { loading: false, loaded: false });
        case customer.EXPAND:
            if ((state.total === state.ids.length) || !state.total) {
                return tslib_1.__assign({}, state, { loading: false });
            }
            else {
                return tslib_1.__assign({}, state, { loading: true });
            }
        case customer.EXPAND_SUCCESS:
            wrap = action.payload;
            generatedData = generateEntities(wrap);
            return tslib_1.__assign({}, state, { ids: state.ids.concat(generatedData.ids), customers: tslib_1.__assign({}, state.customers, generatedData.entities), currentPage: ++state.currentPage, nextPage: ++state.nextPage, loading: false, loaded: true });
        case customer.EXPAND_FAILED:
            return tslib_1.__assign({}, state, { loading: false, loaded: false });
        case customer.SEARCH:
            return tslib_1.__assign({}, state, { loaded: false, loading: true, searchTerm: action.payload });
        case customer.SEARCH_SUCCESS:
            wrap = action.payload;
            generatedData = generateEntities(wrap);
            return tslib_1.__assign({}, state, { loading: false, loaded: true, currentPage: 1, nextPage: 2, totalPages: generatedData.totalPages, ids: generatedData.ids, customers: generatedData.entities });
        case customer.SEARCH_FAILED:
            return tslib_1.__assign({}, state, { loading: false, loaded: false });
        default:
            return state;
    }
}
export var selectCustomerState = createFeatureSelector('customer');
export var getSearchTerm = function (state) { return state.searchTerm; };
export var getCustomersEntities = createSelector(selectCustomerState, function (state) { return state && state.customers; });
